// import React, { useEffect, useState } from "react";
// import axios from "axios";

// import {
//   Grid,
//   Typography,
//   Paper,
//   Box,
//   LinearProgress,
//   CircularProgress,
// } from "@mui/material";

// import {
//   PieChart,
//   Pie,
//   Cell,
//   ResponsiveContainer,
//   BarChart,
//   Bar,
//   CartesianGrid,
//   XAxis,
//   YAxis,
//   Tooltip,
// } from "recharts";

// import Navbar from "../Navbar";
// import Sidebar from "../Sidebar";

// const COLORS = ["#4CAF50", "#FF9800", "#F44336", "#9C27B0"];

// const StatCard = ({ title, value, color }) => (
//   <Paper
//     sx={{
//       p: 3,
//       borderRadius: 4,
//       color: "#fff",
//       background: color,
//       height: "100%",
//       boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
//       transition: "0.3s",
//       "&:hover": {
//         transform: "translateY(-5px)",
//       },
//     }}
//   >
//     <Typography variant="body1">{title}</Typography>

//     <Typography variant="h3" fontWeight="bold" mt={1}>
//       {value}
//     </Typography>
//   </Paper>
// );

// export default function CallDashboard() {
//   const [loading, setLoading] = useState(true);

//   const [dashboardData, setDashboardData] = useState({
//     summary: {},
//     statusDistribution: [],
//     dailyCalls: [],
//     recentActivities: [],
//   });

//   const { API_CONFIG } = require("../../configuration");

//   useEffect(() => {
//     fetchDashboard();
//   }, []);

//   const fetchDashboard = async () => {
//     try {
//       setLoading(true);

//       const token = localStorage.getItem("token");

//       const response = await axios.get(`${API_CONFIG.APIURL}/call/dashboard`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setDashboardData(response.data);
//     } catch (error) {
//       console.error("Dashboard Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <>
//         <Navbar />
//         <Sidebar />

//         <Box
//           display="flex"
//           justifyContent="center"
//           alignItems="center"
//           height="80vh"
//         >
//           <CircularProgress />
//         </Box>
//       </>
//     );
//   }

//   const { summary, statusDistribution, dailyCalls, recentActivities } =
//     dashboardData;

//   return (
//     <>
//       <Navbar />
//       <Sidebar />

//       <Box
//         sx={{
//           p: 3,
//           background: "linear-gradient(180deg,#eef5ff,#f8fbff)",
//           minHeight: "100vh",
//         }}
//       >
//         {/* Header */}
//         <Paper
//           sx={{
//             p: 4,
//             mb: 3,
//             borderRadius: 5,
//             background: "linear-gradient(135deg,#0F2027,#203A43,#2C5364)",
//             color: "#fff",
//           }}
//         >
//           <Typography variant="h4" fontWeight={700}>
//             Call Tracking Dashboard
//           </Typography>

//           <Typography mt={1}>Real Time Telecalling Analytics</Typography>
//         </Paper>

//         {/* KPI */}
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={3}>
//             <StatCard
//               title="Total Sheets"
//               value={summary.totalSheets || 0}
//               color="linear-gradient(135deg,#667eea,#764ba2)"
//             />
//           </Grid>

//           <Grid item xs={12} md={3}>
//             <StatCard
//               title="Total Records"
//               value={summary.totalRecords || 0}
//               color="linear-gradient(135deg,#11998e,#38ef7d)"
//             />
//           </Grid>

//           <Grid item xs={12} md={3}>
//             <StatCard
//               title="Questions"
//               value={summary.totalQuestions || 0}
//               color="linear-gradient(135deg,#f7971e,#ffd200)"
//             />
//           </Grid>

//           <Grid item xs={12} md={3}>
//             <StatCard
//               title="Pending"
//               value={summary.pendingCases || 0}
//               color="linear-gradient(135deg,#ff512f,#dd2476)"
//             />
//           </Grid>
//         </Grid>

//         {/* Charts */}
//         <Grid container spacing={3} mt={1}>
//           <Grid item xs={12} md={5}>
//             <Paper
//               sx={{
//                 p: 3,
//                 borderRadius: 5,
//                 height: 420,
//               }}
//             >
//               <Typography variant="h6" mb={2}>
//                 Call Status
//               </Typography>

//               <ResponsiveContainer width="100%" height="90%">
//                 <PieChart>
//                   <Pie
//                     data={statusDistribution}
//                     dataKey="value"
//                     outerRadius={120}
//                     label
//                   >
//                     {statusDistribution.map((entry, index) => (
//                       <Cell key={index} fill={COLORS[index % COLORS.length]} />
//                     ))}
//                   </Pie>

//                   <Tooltip />
//                 </PieChart>
//               </ResponsiveContainer>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} md={7}>
//             <Paper
//               sx={{
//                 p: 3,
//                 borderRadius: 5,
//                 height: 420,
//               }}
//             >
//               <Typography variant="h6" mb={2}>
//                 Daily Calls
//               </Typography>

//               <ResponsiveContainer width="100%" height="90%">
//                 <BarChart data={dailyCalls}>
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis dataKey="day" />
//                   <YAxis />
//                   <Tooltip />
//                   <Bar dataKey="calls" fill="#1976d2" radius={[10, 10, 0, 0]} />
//                 </BarChart>
//               </ResponsiveContainer>
//             </Paper>
//           </Grid>
//         </Grid>

//         {/* Bottom Cards */}
//         <Grid container spacing={3} mt={1}>
//           <Grid item xs={12} md={6}>
//             <Paper
//               sx={{
//                 p: 3,
//                 borderRadius: 5,
//               }}
//             >
//               <Typography variant="h6">Progress</Typography>

//               <Typography mt={3}>Completed Calls</Typography>

//               <LinearProgress
//                 variant="determinate"
//                 value={72}
//                 sx={{
//                   height: 12,
//                   borderRadius: 10,
//                   mt: 1,
//                 }}
//               />

//               <Typography mt={3}>Pending Calls</Typography>

//               <LinearProgress
//                 variant="determinate"
//                 color="warning"
//                 value={35}
//                 sx={{
//                   height: 12,
//                   borderRadius: 10,
//                   mt: 1,
//                 }}
//               />
//             </Paper>
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <Paper
//               sx={{
//                 p: 3,
//                 borderRadius: 5,
//                 height: "100%",
//               }}
//             >
//               <Typography variant="h6" fontWeight={600} mb={2}>
//                 Recent Activity
//               </Typography>

//               {recentActivities?.length > 0 ? (
//                 recentActivities.map((activity, index) => (
//                   <Box
//                     key={index}
//                     sx={{
//                       p: 2,
//                       mb: 2,
//                       borderRadius: 2,
//                       background: "#f8fafc",
//                       borderLeft: "4px solid #1976d2",
//                     }}
//                   >
//                     <Typography fontWeight={600}>{activity.message}</Typography>

//                     <Typography variant="caption" color="text.secondary">
//                       {activity.time}
//                     </Typography>
//                   </Box>
//                 ))
//               ) : (
//                 <Typography color="text.secondary">
//                   No Recent Activities
//                 </Typography>
//               )}
//             </Paper>
//           </Grid>{" "}
//         </Grid>
//       </Box>
//     </>
//   );
// }

import React, { useEffect, useState } from "react";
import axios from "axios";

import {
  Grid,
  Typography,
  Paper,
  Box,
  CircularProgress,
  LinearProgress,
} from "@mui/material";

import DescriptionIcon from "@mui/icons-material/Description";
import TableChartIcon from "@mui/icons-material/TableChart";
import QuizIcon from "@mui/icons-material/Quiz";
import PendingActionsIcon from "@mui/icons-material/PendingActions";

import Navbar from "../Navbar";
import Sidebar from "../Sidebar";

const StatCard = ({ title, value, icon, iconColor }) => (
  <Paper
    elevation={0}
    sx={{
      p: 3,
      borderRadius: 3,
      border: "1px solid #e5e7eb",
      height: "100%",
    }}
  >
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box>
        <Typography variant="body2" color="text.secondary" mb={1}>
          {title}
        </Typography>

        <Typography variant="h4" fontWeight={700}>
          {value}
        </Typography>
      </Box>

      <Box
        sx={{
          width: 42,
          height: 42,
          borderRadius: 2,
          bgcolor: `${iconColor}20`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: iconColor,
        }}
      >
        {icon}
      </Box>
    </Box>
  </Paper>
);

export default function CallDashboard() {
  const [loading, setLoading] = useState(true);

  const [dashboardData, setDashboardData] = useState({
    summary: {},
    topUsers: [],
    recentActivities: [],
  });

  const { API_CONFIG } = require("../../configuration");

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const response = await axios.get(`${API_CONFIG.APIURL}/call/dashboard`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setDashboardData(response.data);
    } catch (error) {
      console.error(error);

      // Demo Data if API fails
      setDashboardData({
        summary: {
          totalSheets: 24,
          totalRecords: 12450,
          totalQuestions: 86,
          pendingCases: 3210,
        },
        topUsers: [
          {
            name: "John Doe",
            count: 2450,
          },
          {
            name: "Mary Jane",
            count: 1980,
          },
          {
            name: "Peter Parker",
            count: 1450,
          },
          {
            name: "Steve Rogers",
            count: 1120,
          },
          {
            name: "Tony Stark",
            count: 980,
          },
        ],
        recentActivities: [
          {
            message: "Sheet 'June_Customers.xls' assigned app",
            time: "10 mins ago",
          },
          {
            message: "Questions assigned to sheet",
            time: "15 mins ago",
          },
          {
            message: "John answered 25 records",
            time: "1 hour ago",
          },
          {
            message: "Mary answered 40 records",
            time: "2 hours ago",
          },
          {
            message: "Admin created new question",
            time: "3 hours ago",
          },
        ],
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <Sidebar />

        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="80vh"
        >
          <CircularProgress />
        </Box>
      </>
    );
  }

  // const { summary, topUsers, recentActivities } =
  //   dashboardData;
  const summary = dashboardData?.summary || {};
  const topUsers = dashboardData?.topUsers || [];
  const recentActivities = dashboardData?.recentActivities || [];

  const answered = (summary.totalRecords || 0) - (summary.pendingCases || 0);

  const progress =
    summary.totalRecords > 0
      ? Math.round((answered / summary.totalRecords) * 100)
      : 0;

  return (
    <>
      <Navbar />
      <Sidebar />

      <Box
        sx={{
          p: { xs: 1, sm: 2, md: 3 },
          ml: { xs: 0, md: "250px" },
          width: {
            xs: "100%",
            md: "calc(100% - 250px)",
          },
          boxSizing: "border-box",
          overflowX: "hidden",
        }}
      >
        {/* Header Banner */}
        <Paper
          elevation={0}
          sx={{
            mb: 3,
            p: 4,
            borderRadius: 4,
            background: "linear-gradient(135deg,#2563eb,#4f46e5)",
            color: "#fff",
          }}
        >
          <Typography variant="h4" fontWeight={700}>
            Call Tracking Dashboard
          </Typography>

          <Typography sx={{ mt: 1, opacity: 0.9 }}>
            Monitor telecaller performance and customer responses
          </Typography>
        </Paper>

        {/* KPI */}
        <Grid container spacing={3}>
          {[
            {
              title: "Total Sheets",
              value: summary.totalSheets || 0,
              color: "#2563eb",
            },
            {
              title: "Total Records",
              value: summary.totalRecords || 0,
              color: "#16a34a",
            },
            {
              title: "Total Questions",
              value: summary.totalQuestions || 0,
              color: "#7c3aed",
            },
            {
              title: "Pending Answers",
              value: summary.pendingCases || 0,
              color: "#ea580c",
            },
          ].map((item, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: 4,
                  background: "linear-gradient(135deg,#fff,#f8fafc)",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                  transition: "0.3s",
                  "&:hover": {
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <Typography color="text.secondary" variant="body2">
                  {item.title}
                </Typography>

                <Typography variant="h3" fontWeight={700} mt={1}>
                  {item.value}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Grid container spacing={3} mt={1}>
          {/* Progress */}
          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 4,
                height: 420,
                border: "1px solid #e2e8f0",
                boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
              }}
            >
              <Typography variant="h6" fontWeight={600}>
                Answers Progress
              </Typography>

              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="260px"
              >
                <Box sx={{ position: "relative" }}>
                  <CircularProgress
                    variant="determinate"
                    value={100}
                    size={180}
                    thickness={4}
                    sx={{
                      color: "#e5e7eb",
                      position: "absolute",
                    }}
                  />

                  <CircularProgress
                    variant="determinate"
                    value={progress}
                    size={180}
                    thickness={4}
                    sx={{
                      color: "#2563eb",
                    }}
                  />

                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Typography variant="h3" fontWeight={700}>
                      {progress}%
                    </Typography>

                    <Typography color="text.secondary">
                      {/* Completed */}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Typography color="primary" fontWeight={600}>
                ● Answered ({answered})
              </Typography>

              <Typography color="text.secondary" mt={1}>
                ● Pending ({summary.pendingCases || 0})
              </Typography>
            </Paper>
          </Grid>

          {/* Top Users */}
          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 4,
                height: 420,
                border: "1px solid #e2e8f0",
                boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
              }}
            >
              <Typography variant="h6" fontWeight={600} mb={3}>
                Top Performers
              </Typography>

              {topUsers.length > 0 ? (
                topUsers.map((user, index) => (
                  <Box key={index} mb={3}>
                    <Box display="flex" justifyContent="space-between" mb={1}>
                      <Typography>{user.name}</Typography>

                      <Typography fontWeight={700}>{user.count}</Typography>
                    </Box>

                    <LinearProgress
                      variant="determinate"
                      value={
                        topUsers[0]?.count
                          ? (user.count / topUsers[0].count) * 100
                          : 0
                      }
                      sx={{
                        height: 10,
                        borderRadius: 5,
                      }}
                    />
                  </Box>
                ))
              ) : (
                <Box
                  sx={{
                    height: 250,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#94a3b8",
                  }}
                >
                  No User Data Available
                </Box>
              )}
            </Paper>
          </Grid>

          {/* Activity */}
          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 4,
                height: 420,
                border: "1px solid #e2e8f0",
                boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                overflowY: "auto",
              }}
            >
              <Typography variant="h6" fontWeight={600} mb={3}>
                Recent Activity
              </Typography>

              <Box
                sx={{
                  borderLeft: "3px solid #2563eb",
                  pl: 3,
                }}
              >
                {recentActivities.length > 0 ? (
                  recentActivities.map((activity, index) => (
                    <Box key={index} mb={3}>
                      <Typography fontWeight={500}>
                        {activity.message}
                      </Typography>

                      <Typography variant="caption" color="text.secondary">
                        {new Date(activity.time).toLocaleString()}
                      </Typography>
                    </Box>
                  ))
                ) : (
                  <Typography color="text.secondary">
                    No Activity Found
                  </Typography>
                )}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
